document.addEventListener('DOMContentLoaded', function() {
    const areaSelectors = document.querySelectorAll('select.webien-area-select');
    const areaSelectDisplays = document.querySelectorAll('.area-content-display-container');
    if (areaSelectors.length > 0) {
        areaSelectors.forEach(areaSelect => {
            areaSelect.addEventListener('change', function() {
                const selectedArea = this.value;

                // Search in content array for the selected area
                let match = areaSpecificContent.find(item => parseFloat(item.area) === parseFloat(selectedArea));
                if(match) {
                    areaSelectDisplays.forEach(el => {
                        el.innerHTML = match.areaContent;
                    });
                }
            });
            // Trigger change event on page load to show the correct area
            areaSelect.dispatchEvent(new Event('change'));
        });
    }
});